import { render, staticRenderFns } from "./tab-layout.vue?vue&type=template&id=65be9a56&scoped=true"
import script from "./tab-layout.vue?vue&type=script&lang=js"
export * from "./tab-layout.vue?vue&type=script&lang=js"
import style0 from "./tab-layout.vue?vue&type=style&index=0&id=65be9a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65be9a56",
  null
  
)

export default component.exports